import React from 'react';

const VideoTutorialModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  // Convert YouTube Shorts URL to embed format
  const videoId = 'wXbpMdZGWQQ';
  const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`;

  return (
    <div 
      className="video-tutorial-overlay"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000,
        padding: '20px'
      }}
      onClick={onClose}
    >
      <div 
        className="video-tutorial-modal"
        style={{
          background: '#000000',
          border: '4px solid #FFFFFF',
          borderRadius: '0',
          boxShadow: '8px 8px 0px #333333',
          maxWidth: '90vw',
          maxHeight: '90vh',
          width: '600px',
          height: '400px',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{
          background: '#FFFFFF',
          color: '#D72638',
          padding: '16px 20px',
          borderBottom: '3px solid #000000',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h3 style={{
            margin: 0,
            fontSize: '18px',
            fontWeight: '900',
            fontFamily: "'Arial Black', sans-serif",
            textTransform: 'uppercase',
            letterSpacing: '0.1em',
            color: '#D72638',
            textShadow: '2px 2px 0px #000000'
          }}>
            📺 Getting Started Tutorial
          </h3>
          <button
            onClick={onClose}
            style={{
              background: '#D72638',
              border: '3px solid #000000',
              borderRadius: '0',
              color: '#FFFFFF',
              width: '32px',
              height: '32px',
              fontSize: '16px',
              fontWeight: '900',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '3px 3px 0px #333333'
            }}
          >
            ✕
          </button>
        </div>

        {/* Video Container */}
        <div style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '16px',
          background: '#000000'
        }}>
          <iframe
            src={embedUrl}
            title="Kids Investment Game Tutorial"
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
              borderRadius: '0'
            }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>

        {/* Footer */}
        <div style={{
          background: '#f59e0b',
          color: '#D72638',
          padding: '12px 20px',
          borderTop: '3px solid #000000',
          textAlign: 'center'
        }}>
          <p style={{
            margin: 0,
            fontSize: '14px',
            fontWeight: '700',
            fontFamily: "'Arial Black', sans-serif",
            color: '#D72638',
            textShadow: '1px 1px 0px #000000'
          }}>
            This tutorial is also available in the menu anytime!
          </p>
        </div>
      </div>

      {/* Mobile Responsive Styles */}
      <style jsx>{`
        @media (max-width: 768px) {
          .video-tutorial-modal {
            width: 95vw !important;
            height: 70vh !important;
            max-width: none !important;
          }
        }
        
        @media (max-width: 480px) {
          .video-tutorial-modal {
            width: 98vw !important;
            height: 60vh !important;
          }
        }
      `}</style>
    </div>
  );
};

export default VideoTutorialModal;